<template>
  <div class="settings">
    <div class="settings_header">
      <h1>Invoice Settings</h1>
      <div class="description">
        Any changes will be applied to your upcoming invoices.
      </div>
    </div>
    <div class="settingsContainer">
      <div class="frameGroup">
        <div class="inputGroup">
          <label>First Name</label>
          <input type="text" v-model="form.firstName" />
        </div>
        <div class="inputGroup">
          <label>Last Name</label>
          <input type="text" v-model="form.lastName" />
        </div>
      </div>
      <div class="frameGroup">
        <div class="inputGroup">
          <label>Company Name</label>
          <input type="text" v-model="form.companyName" />
        </div>
        <div class="inputGroup">
          <label>Address</label>
          <input type="text" v-model="form.address" />
        </div>
      </div>
      <div class="frameGroup">
        <div class="inputGroup">
          <label>City</label>
          <input type="text" v-model="form.city" />
        </div>
        <div class="inputGroup">
          <label>Postal Code</label>
          <input type="text" v-model="form.postalCode" />
        </div>
      </div>
      <div class="frameGroup">
        <div class="inputGroup">
          <label>Country</label>
          <input type="text" v-model="form.country" />
        </div>
        <div class="inputGroup">
          <label>State</label>
          <input type="text" v-model="form.state" />
        </div>
      </div>
      <button :disabled="isFormValid" @click="updateInvoice">
        <span>Update</span>
      </button>
    </div>
  </div>
</template>

<script>
import { useLoginStore } from "../../../../../../stores/loginStore";
import InvoicesAPIService from "../../../../../../servicehandlers/InvoiceAPIService";

const invoiceAPIService = new InvoicesAPIService();
export default {
  name: "InvoiceSettings",
  data() {
    return {
      form: {
        firstName: "",
        lastName: "",
        companyName: "",
        address: "",
        city: "",
        postalCode: "",
        state: "",
        country: "",
      },
      settings: null,
      isFormValid: true,
      flightSchoolId: useLoginStore().getUser.flightSchoolId,
    };
  },
  mounted() {
    this.getInvoiceSettings();
  },
  watch: {
    form: {
      handler(newForm) {
        this.isFormValid = Object.keys(newForm).every(
          (key) => newForm[key] === this.settings[key],
        );
      },
      deep: true,
    },
  },
  methods: {
    getInvoiceSettings() {
      return invoiceAPIService
        .getInvoiceSettingsForSchool(this.flightSchoolId, this.$router)
        .then((response) => {
          this.form.firstName = response.firstName;
          this.form.lastName = response.lastName;
          this.form.companyName = response.companyName;
          this.form.address = response.address;
          this.form.city = response.city;
          this.form.postalCode = response.postalCode;
          this.form.state = response.state;
          this.form.country = response.country;
          this.settings = response;
        });
    },
    updateInvoice() {
      for (let key of Object.keys(this.form)) {
        this.settings[key] = this.form[key];
      }

      return invoiceAPIService
        .updateInvoiceSetting(this.settings.id, this.settings, this.$router)
        .then(() => {
          this.getInvoiceSettings();
          this.isFormValid = true;
        });
    },
  },
  /*setup() {
    const form = reactive({
      firstName: "Tyler",
      lastName: "Johnson",
      companyName: "Venture West Aviation",
      address: "2443 N Greenfield rd",
      city: "Mesa",
      postalCode: "85215",
      country: "USA",
      state: "Arizona",
    });

    const isFormValid = computed(() => {
      return Object.values(form).every((value) => value.trim() !== "");
    });

    const updateInvoice = () => {
      alert("Invoice settings updated!");
    };

    return { form, isFormValid, updateInvoice };
  },*/
};
</script>

<style scoped lang="scss">
.settings {
  max-width: 780px;
  padding: 20px;

  .settings_header {
    h1 {
      color: #404040;
      font-size: 28px;
      font-weight: 700;
      margin-bottom: 10px;
    }

    .description {
      font-size: 14px;
      color: #666;
      margin-bottom: 20px;
    }
  }

  .settingsContainer {
    border: 1px solid rgba(64, 64, 64, 0.25);
    border-radius: 15px;
    padding: 20px;
  }

  .frameGroup {
    display: flex;
    gap: 20px;
    margin-bottom: 15px;

    @media (max-width: 600px) {
      flex-direction: column;
    }
  }

  .inputGroup {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 5px;

    label {
      font-size: 14px;
      color: #404040;
    }

    input {
      width: 100%;
      padding: 10px;
      font-size: 14px;
      border: none;
      border-radius: 8px;
      background: rgba(64, 64, 64, 0.05);
      outline: none;
      transition: border 0.2s ease-in-out;

      &:focus {
        border: 1px solid #3c78ff;
      }
    }
  }

  button {
    width: auto;
    margin-top: 10px;
    padding: 8px 12px;
    font-size: 14px;
    color: white;
    background-color: #3c78ff;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    transition: background 0.3s ease-in-out;
    font-weight: 300;

    &:disabled {
      background-color: #b0b0b0;
      cursor: not-allowed;
    }

    &:hover:not(:disabled) {
      background-color: #2a5dc7;
    }
  }
}
</style>
